/* Fragrance advisor chat — streams OpenAI-style SSE from the configured endpoint. */
(function () {
  var root = document.querySelector('[data-chat]');
  if (!root) return;
  var openBtn = root.querySelector('[data-chat-open]');
  var panel = root.querySelector('[data-chat-panel]');
  var log = root.querySelector('[data-chat-log]');
  var welcome = root.querySelector('[data-chat-welcome]');
  var form = root.querySelector('[data-chat-form]');
  var input = root.querySelector('[data-chat-input]');
  var send = form.querySelector('[type=submit]');
  var messages = [];
  var busy = false;

  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function inline(s) {
    return esc(s)
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/(^|[^*])\*(?!\s)(.+?)\*/g, '$1<em>$2</em>')
      .replace(/\[([^\]]+)\]\(((?:https?:\/\/|\/)[^)\s]+)\)/g, '<a href="$2">$1</a>');
  }
  function md(text) {
    var out = [], list = null;
    text.split('\n').forEach(function (line) {
      var ul = line.match(/^\s*[-*]\s+(.*)/), ol = line.match(/^\s*\d+\.\s+(.*)/), h = line.match(/^#{1,6}\s+(.*)/);
      if (ul || ol) {
        var type = ul ? 'ul' : 'ol';
        if (list !== type) { if (list) out.push('</' + list + '>'); out.push('<' + type + '>'); list = type; }
        out.push('<li>' + inline((ul || ol)[1]) + '</li>');
        return;
      }
      if (list) { out.push('</' + list + '>'); list = null; }
      if (h) out.push('<p><strong>' + inline(h[1]) + '</strong></p>');
      else if (line.trim()) out.push('<p>' + inline(line) + '</p>');
    });
    if (list) out.push('</' + list + '>');
    return out.join('');
  }

  function tpl(name) { return root.querySelector('[data-chat-tpl-' + name + ']').content.firstElementChild.cloneNode(true); }
  function scroll() { log.scrollTop = log.scrollHeight; }
  function sync() { send.disabled = busy || !input.value.trim(); input.disabled = busy; }

  function open() { panel.hidden = false; openBtn.hidden = true; setTimeout(function () { input.focus(); }, 50); }
  function close() { panel.hidden = true; openBtn.hidden = false; }
  openBtn.addEventListener('click', open);
  root.querySelector('[data-chat-close]').addEventListener('click', close);
  root.querySelectorAll('[data-chat-suggest]').forEach(function (b) {
    b.addEventListener('click', function () { input.value = b.textContent.trim(); sync(); input.focus(); });
  });
  input.addEventListener('input', sync);

  function addUser(text) {
    if (welcome) { welcome.remove(); welcome = null; }
    var el = tpl('user'); el.firstElementChild.textContent = text; log.appendChild(el); scroll();
  }
  function addBot() { var el = tpl('bot'); log.appendChild(el); return el.querySelector('.brogi-md'); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text || busy) return;
    messages.push({ role: 'user', content: text });
    addUser(text);
    input.value = ''; busy = true; sync();
    var loading = tpl('loading'); log.appendChild(loading); scroll();
    var bot = null, acc = '';

    var headers = { 'Content-Type': 'application/json' };
    if (root.dataset.key) headers.Authorization = 'Bearer ' + root.dataset.key;
    fetch(root.dataset.endpoint, { method: 'POST', headers: headers, body: JSON.stringify({ messages: messages }) })
      .then(function (res) {
        if (!res.ok || !res.body) throw new Error('Failed to connect');
        var reader = res.body.getReader(), dec = new TextDecoder(), buf = '';
        function pump() {
          return reader.read().then(function (r) {
            if (r.done) return;
            buf += dec.decode(r.value, { stream: true });
            var idx;
            while ((idx = buf.indexOf('\n')) !== -1) {
              var line = buf.slice(0, idx); buf = buf.slice(idx + 1);
              if (line.endsWith('\r')) line = line.slice(0, -1);
              if (!line.startsWith('data: ')) continue;
              var data = line.slice(6).trim();
              if (data === '[DONE]') return;
              try {
                var j = JSON.parse(data);
                var delta = j.choices && j.choices[0] && j.choices[0].delta && j.choices[0].delta.content;
                if (delta) {
                  acc += delta;
                  if (!bot) { loading.remove(); bot = addBot(); }
                  bot.innerHTML = md(acc); scroll();
                }
              } catch (err) { buf = line + '\n' + buf; break; }
            }
            return pump();
          });
        }
        return pump();
      })
      .then(function () { if (acc) messages.push({ role: 'assistant', content: acc }); })
      .catch(function () {
        var m = root.dataset.error;
        if (!bot) bot = addBot();
        bot.innerHTML = md(m);
        messages.push({ role: 'assistant', content: m });
      })
      .finally(function () { loading.remove(); busy = false; sync(); scroll(); });
  });
})();
